{
  "hero": {
    "title": "Resources and Reusables",
    "description": "Browse guidance, design references and implementation examples to help you ship consistent, accessible experiences.",
    "heroImage": "/assets/img/hero-image.png",
    "heroImageAlt": "D&AS hero art"
  },
  "nav": [
    {
      "name": "Code Contribution",
      "href": "/resources-and-reusables/code-contribution/"
    },
    {
      "name": "UI Design Gallery",
      "href": "/resources-and-reusables/ui-design-gallery/"
    },
    {
      "name": "Reusable Catalog",
      "href": "/resources-and-reusables/reusable-catalog/"
    },
    {
      "name": "Commercial & R&D",
      "href": "/resources-and-reusables/commercial-and-rd/"
    }
  ],
  "stats": [
    {
      "label": "Clients Onboarded",
      "value": "20+"
    },
    {
      "label": "Days to 1st Dashboard",
      "value": "10-30"
    },
    {
      "label": "Data Sources Integrated",
      "value": "15+"
    },
    {
      "label": "Practitioners",
      "value": "30+"
    }
  ],
  "members": [
    {
      "name": "Nathanael Jhonn R Aguas",
      "role": "Service Consultant",
      "language": [
        "Python",
        "SQL",
        "JavaScript"
      ],
      "skill": [
        "Classification Models",
        "Document Handling"
      ],
      "assigned_projects": [
        "New Project 1",
        "New Project 2"
      ],
      "past_projects": [
        "Jekyll - Markdown Usecase as Webpage.",
        "Procurement Browser Extension",
        "Telemetry",
        "Agentic Knowledge Assistant",
        "Project5",
        "Project2",
        "Project3",
        "Project4",
        "Project2",
        "Project3",
        "Project4",
        "Project5",
        "Project2",
        "Project3",
        "Project4"
      ],
      "isActive": true
    },
    {
      "name": "John Michael M Batula",
      "role": "Service Consultant",
      "language": [
        "Python"
      ],
      "skill": [],
      "assigned_projects": [
        "New Project 1"
      ],
      "past_projects": [
        "Project1",
        "Project2"
      ],
      "isActive": true
    },
    {
      "name": "Edmichael Joil D Fajardo",
      "role": "Principal Consultant",
      "language": [
        "Python"
      ],
      "skill": [
        "Computer Vision",
        "Document Handling",
        "Tme-Series Forecasting"
      ],
      "assigned_projects": [
        "New Project 1",
        "New Project 2"
      ],
      "past_projects": [
        "Project3",
        "Project4"
      ],
      "isActive": true
    },
    {
      "name": "Samuel L Oronos",
      "role": "Service Consultant",
      "language": [
        "Python",
        "C#",
        "RPA",
        "VBA"
      ],
      "skill": [
        "PowerAutomate",
        "BluePrism",
        "PowerBI",
        "Automation Anywhere",
        "UIPATH",
        "Infrastructure",
        "Deployment",
        "Data Analytics"
      ],
      "assigned_projects": [
        "New Project 2"
      ],
      "isActive": true
    },
    {
      "name": "Reyner Mark D Halili",
      "role": "Service Consultant",
      "language": [
        "SQL",
        "VBA",
        "VB"
      ],
      "skill": [
        "PowerAutomate",
        "Data Analytics",
        "Automation Anywhere",
        "UIPATH",
        "Business Intelligence"
      ],
      "isActive": true
    },
    {
      "name": "Andrea Yna M Madarang",
      "role": "Service Consultant",
      "language": [
        "Python"
      ],
      "skill": [
        "Business Intelligence",
        "Data Analytics"
      ],
      "isActive": true
    },
    {
      "name": "Ramher N Pangindian",
      "role": "Principal Consultant",
      "language": [],
      "skill": [
        "Business Intelligence",
        "PowerBI"
      ],
      "isActive": true
    },
    {
      "name": "Jennie Lyn C Batas",
      "role": "Principal Consultant",
      "language": [
        "Python",
        "C#",
        "TypeScript",
        "Java",
        "SQL",
        "RPA"
      ],
      "skill": [
        "Full Stack",
        "PowerBI",
        "BluePrism",
        "Business Intelligence",
        "API Creation",
        "API Integration",
        "PowerAutomate",
        "QA Testing (Manual)",
        "Web Development",
        "Automation Anywhere",
        "UIPATH",
        "RAG Models"
      ],
      "isActive": true
    },
    {
      "name": "Rosuello Vincent A Legaspi",
      "role": "Associate Consultant",
      "language": [
        "Python",
        "Java",
        "PHP",
        "TypeScript",
        "JavaScript",
        "Angular",
        "NodeJS",
        "ReactJS"
      ],
      "skill": [
        "Full Stack",
        "Web Development",
        "NLP",
        "LLM Implementation"
      ],
      "isActive": true
    },
    {
      "name": "Maria Katrina J Varquez",
      "role": "Service Consultant",
      "language": [
        "PowerShell",
        "Python",
        "SQL",
        "RPA",
        "C#",
        "JavaScript",
        "VBA"
      ],
      "skill": [
        "PowerAutomate",
        "BluePrism"
      ],
      "isActive": true
    },
    {
      "name": "Alec Justin Rodriguez",
      "role": "Service Consultant",
      "language": [
        "TypeScript"
      ],
      "skill": [
        "Front End Development",
        "Back End Development",
        "Web Development",
        "Full Stack"
      ],
      "isActive": true
    },
    {
      "name": "Kenji A Kotani",
      "role": "Junior Consultant",
      "language": [
        "Python",
        "TypeScript",
        "C#",
        "Java",
        "PHP"
      ],
      "skill": [
        "Full Stack",
        "Web Development",
        "Regression Models",
        "Classification Models",
        "LLM Implementation"
      ],
      "isActive": true
    },
    {
      "name": "Samuel Allen L Gelacio",
      "role": "Service Consultant",
      "language": [
        "Python",
        "PHP",
        "ReactJS",
        "PBI",
        "WordPress",
        "Wix",
        "Java",
        "TypeScript",
        "SQL",
        "JavaScript",
        "C++",
        "Angular",
        "NodeJS",
        "HTML",
        "CSS",
        "React Native"
      ],
      "skill": [
        "PowerBI",
        "PowerPages",
        "Web Development",
        "Front End Development",
        "Back End Development"
      ],
      "isActive": true
    },
    {
      "name": "Mark Gerald P Giba",
      "role": "Junior Consultant",
      "language": [
        "Python"
      ],
      "skill": [
        "NLP",
        "Document Handling",
        "Classification Models",
        "Computer Vision"
      ],
      "isActive": true
    },
    {
      "name": "Jewel Anne B Panela",
      "role": "Junior Consultant",
      "language": [
        "Python",
        "SQL",
        "C++",
        "Kotlin",
        "Java"
      ],
      "skill": [
        "Back End Development",
        "NLP",
        "Classification Models"
      ],
      "isActive": true
    },
    {
      "name": "Phoebe Kelly C Liwanag",
      "role": "Junior Consultant",
      "language": [
        "Python",
        "HTML",
        "Java"
      ],
      "skill": [
        "API Integration",
        "Tme-Series Forecasting"
      ],
      "isActive": true
    },
    {
      "name": "Karth Ian P Macalalad",
      "role": "Principal Consultant",
      "language": [
        "Python"
      ],
      "skill": [
        "Deployment",
        "NLP",
        "RAG Models",
        "Tme-Series Forecasting",
        "Classification Models",
        "Clustering Models",
        "Regression Models",
        "LLM Implementation"
      ],
      "isActive": true
    },
    {
      "name": "John Marie L Naidas",
      "role": "Principal Consultant",
      "language": [
        "Python",
        "C#",
        "JavaScript",
        "HTML",
        "SQL",
        "NodeJS",
        "CSS",
        "ReactJS"
      ],
      "skill": [
        "Infrastructure",
        "Deployment",
        "Full Stack",
        "PowerBI",
        "Business Intelligence",
        "Web Development"
      ],
      "isActive": true
    },
    {
      "name": "Ruth R Morallos",
      "role": "Junior Consultant",
      "language": [
        "Python",
        "Java",
        "TypeScript",
        "SQL",
        "JavaScript"
      ],
      "skill": [
        "Full Stack",
        "QA Testing (Manual)",
        "QA Testing (Automated)",
        "NLP",
        "Document Handling",
        "Web Development",
        "Data Analytics",
        "Classification Models",
        "Clustering Models",
        "AI/ML Model Training"
      ],
      "isActive": true
    },
    {
      "name": "Angelica P Ware",
      "role": "Service Consultant",
      "language": [
        "Angular",
        "HTML",
        "CSS",
        "JavaScript",
        "TypeScript",
        "ReactJS",
        "Kotlin",
        "PowerShell"
      ],
      "skill": [
        "UI/UX",
        "Web Development",
        "PowerApps",
        "Front End Development",
        "Figma"
      ],
      "isActive": true
    },
    {
      "name": "Genrev Kiel A Hizon",
      "role": "Service Consultant",
      "language": [
        "Python"
      ],
      "skill": [
        "Classification Models",
        "Regression Models",
        "LLM Implementation",
        "NLP",
        "Computer Vision",
        "API Creation",
        "PowerBI",
        "Data Analytics"
      ],
      "isActive": true
    },
    {
      "name": "Charles Erickson B Alcordo",
      "role": "Principal Consultant",
      "language": [
        "C#",
        "TypeScript",
        "SQL",
        "JavaScript",
        "VB"
      ],
      "skill": [
        "Full Stack",
        "API Integration",
        "API Creation",
        "Web Development",
        "Front End Development",
        "Deployment",
        "Back End Development"
      ],
      "isActive": true
    },
    {
      "name": "Hannah Franchette Laxa",
      "role": "Lead Consultant",
      "language": [
        "Flutter Dart",
        "JavaScript",
        "HTML",
        "PHP",
        "TypeScript",
        "Python",
        "VB Macro",
        "SQL"
      ],
      "skill": [
        "Web Development",
        "Front End Development",
        "Agile Methodology",
        "Back End Development",
        "Scrum",
        "OpenShift Deployment",
        "Containerization",
        "Docker",
        "Full Stack",
        "API Creation",
        "Deployment"
      ],
      "isActive": true
    },
    {
      "name": "Marianne Nicole L Zulueta",
      "role": "Junior Consultant",
      "language": [],
      "skill": [],
      "isActive": true
    },
    {
      "name": "Beatrice Micaela G Ramirez",
      "role": "",
      "language": [
        "Python",
        "Java",
        "PHP",
        "SQL",
        "RPA",
        "JavaScript",
        "HTML",
        "CSS",
        "PBI"
      ],
      "skill": [
        "Web Development",
        "Front End Development",
        "UIPATH",
        "Back End Development",
        "PowerBI"
      ],
      "isActive": true
    },
    {
      "name": "Jacqueline Cate S Catley",
      "role": "Service Consultant",
      "language": [
        "Python",
        "C++",
        "TypeScript",
        "HTML",
        "CSS",
        "C"
      ],
      "skill": [
        "Computer Vision",
        "NLP",
        "Classification Models",
        "Front End Development"
      ],
      "isActive": false
    },
    {
      "name": "Gerardo Jr. D Eslabra",
      "role": "Service Consultant",
      "language": [
        "RPA",
        "VBA",
        "HTML",
        "VB Macro",
        "PBI"
      ],
      "skill": [
        "BluePrism",
        "PowerBI",
        "UIPATH"
      ],
      "isActive": true
    },
    {
      "name": "Frank P Katada Jr.",
      "role": "Manager Consulting Expert",
      "language": [
        "Python",
        "TypeScript",
        "ReactJS",
        "NodeJS",
        "PowerShell",
        "PBI",
        "JavaScript",
        "SQL",
        "C#"
      ],
      "skill": [],
      "isActive": true
    }
  ],
  "projects": [
    {
      "title": "Jekyll - Markdown Usecase as Webpage.",
      "engagement": "R&D",
      "modified": "2025-11-20 14:25",
      "subBU": "CAMS",
      "priority": "Low",
      "assignee": [
        "Gelacio, Samuel Allen L",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Frank",
      "initiatedOn": "2025-07-01 15:23",
      "category": "",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "2025-06-23",
      "id": "134",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "7-10-2025",
          "expiresAt": "7-23-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "11-26-2025",
          "expiresAt": "12-28-2027"
        }
      ],
      "prototypeUrl": "https://embed.figma.com/design/7xbitFLxVfE0Hspi6Y8g7I/Jekyll?node-id=3-13800&m=dev&embed-host=share",
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Procurement Browser Extension",
      "engagement": "BU",
      "modified": "2025-11-18 08:34",
      "subBU": "BU",
      "priority": "Medium",
      "assignee": [
        "Ramirez, Candy",
        "Varquez, Maria Katrina J",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "NEW",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Aive",
      "initiatedOn": "2025-11-18 08:32",
      "category": "",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "156",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "9-19-2025",
          "expiresAt": "11-19-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "10-25-2025",
          "expiresAt": "10-30-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "7-25-2025",
          "expiresAt": "9-25-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Browser Extension: PSA",
      "engagement": "Internal",
      "modified": "2025-11-17 14:35",
      "subBU": "BU",
      "priority": "High",
      "assignee": [
        "Varquez, Maria Katrina J",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "WAITING FOR FEEDBACK",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Ron",
      "initiatedOn": "2025-04-09 18:00",
      "category": "[\"Automation, Integration\"]",
      "primaryTechStack": [
        "W3C"
      ],
      "technology": [
        "Browser Extension"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "1",
      "estimates": "",
      "dueOn": "",
      "id": "6",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "8-23-2025",
          "expiresAt": "9-26-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "6-19-2025",
          "expiresAt": "11-24-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "7-19-2025",
          "expiresAt": "11-24-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "gallery": [
        {
          "src": "/assets/img/gallery/psa-browser-extension/login.png",
          "caption": "Login"
        },
        {
          "src": "/assets/img/gallery/psa-browser-extension/log_time.png",
          "caption": "Log Time Form"
        },
        {
          "src": "/assets/img/gallery/psa-browser-extension/work_log_helper.png",
          "caption": "Work Log Helper"
        }
      ],
      "isVisible": true
    },
    {
      "title": "QA - SS",
      "engagement": "CAMS",
      "modified": "2025-11-06 11:44",
      "subBU": "CAMS",
      "priority": "High",
      "assignee": [
        "Ladion, John Clifford M",
        "Batas, Jennie Lyn C"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Ren/ida",
      "initiatedOn": "2025-11-06 10:14",
      "category": "[\"Fullstack\",\"Integration\",\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "151",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "3-5-2025",
          "expiresAt": "10-5-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "6-18-2025",
          "expiresAt": "8-24-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "7-15-2025",
          "expiresAt": "12-28-2026"
        },
        {
          "name": "Access 4",
          "grantedOn": "12-24-2025",
          "expiresAt": "12-24-2027"
        },
        {
          "name": "Access 5",
          "grantedOn": "3-12-2025",
          "expiresAt": "8-29-2025"
        }
      ],
      "prototypeUrl": "https://embed.figma.com/design/49BVtwKYXHTvdYz0KsSCGe/QA-Tool-Shared-Services?node-id=0-1&m=dev&embed-host=share",
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "BMO SD: QA-Forms",
      "engagement": "BMo",
      "modified": "2025-11-06 11:44",
      "subBU": "EUSS",
      "priority": "Medium",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "NEW",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Ron",
      "initiatedOn": "2025-11-06 10:20",
      "category": "",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "152",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "6-7-2025",
          "expiresAt": "9-27-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "CI FIN RESP Notional Calculation",
      "engagement": "CI Fin",
      "modified": "2025-11-06 10:27",
      "subBU": "CBPS",
      "priority": "High",
      "assignee": [
        "Halili, Reyner Mark D",
        "Oronos, Samuel L",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Q",
      "initiatedOn": "2025-11-06 10:26",
      "category": "",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "155",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "6-16-2025",
          "expiresAt": "10-28-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "CI OPMT",
      "engagement": "CI Fin",
      "modified": "2025-11-06 10:26",
      "subBU": "CBPS",
      "priority": "High",
      "assignee": [
        "Oronos, Samuel L",
        "Halili, Reyner Mark D",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "",
      "initiatedOn": "2025-11-06 10:24",
      "category": "[\"Automation\"]",
      "primaryTechStack": [
        "Typescript",
        " React. Python"
      ],
      "technology": [
        "Browser Extension"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "154",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "9-10-2025",
          "expiresAt": "12-24-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "5-11-2025",
          "expiresAt": "11-23-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "CI QA FORMS",
      "engagement": "CI Fin",
      "modified": "2025-11-06 10:23",
      "subBU": "CBPS",
      "priority": "High",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "KJ, Jon, Queene",
      "initiatedOn": "2025-11-06 10:23",
      "category": "",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "153",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "3-15-2025",
          "expiresAt": "6-26-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "BMO TPS Audit, Coaching and Dispute Phase 1",
      "engagement": "BMo",
      "modified": "2025-11-06 10:20",
      "subBU": "EUSS",
      "priority": "Critical",
      "assignee": [
        "Alcordo, Charles Erickson B",
        "Batas, Jennie Lyn C",
        "Kotani, Kenji A",
        "Ware, Angelica P"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Miss Pauline",
      "initiatedOn": "2025-04-22 13:26",
      "category": "[\"AI\",\"Fullstack\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "2025-08-06",
      "id": "140",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "8-15-2025",
          "expiresAt": "11-25-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "4-18-2025",
          "expiresAt": "7-20-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "12-5-2025",
          "expiresAt": "12-29-2025"
        },
        {
          "name": "Access 4",
          "grantedOn": "11-6-2025",
          "expiresAt": "12-7-2027"
        },
        {
          "name": "Access 5",
          "grantedOn": "6-1-2025",
          "expiresAt": "6-30-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Agentic Knowledge Assistant (AKA)",
      "engagement": "Aspen",
      "modified": "2025-11-06 10:17",
      "subBU": "CAMS",
      "priority": "High",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Jeff",
      "initiatedOn": "2025-08-26 18:25",
      "category": "[\"AI\",\"Integration\",\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "144",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "2-24-2025",
          "expiresAt": "7-27-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "5-12-2025",
          "expiresAt": "12-28-2026"
        },
        {
          "name": "Access 3",
          "grantedOn": "10-8-2025",
          "expiresAt": "10-8-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Foresters - Predictive Intelligence",
      "engagement": "Foresters",
      "modified": "2025-11-06 10:16",
      "subBU": "EUSS",
      "priority": "Medium",
      "assignee": [
        "Hizon, Genrev Kiel A",
        "Eslabra, Gerardo Jr. D",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Villena, Catherine Gem",
      "initiatedOn": "2025-11-06 10:03",
      "category": "",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "150",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "10-13-2025",
          "expiresAt": "10-20-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "1-22-2025",
          "expiresAt": "10-30-2026"
        },
        {
          "name": "Access 3",
          "grantedOn": "12-2-2025",
          "expiresAt": "12-26-2025"
        },
        {
          "name": "Access 4",
          "grantedOn": "10-12-2025",
          "expiresAt": "12-20-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Command Center",
      "engagement": "CI Fin",
      "modified": "2025-11-06 10:02",
      "subBU": "CBPS",
      "priority": "Critical",
      "assignee": [
        "Katada Jr., Frank P",
        "Rodriguez, Alec Justin",
        "Fajardo, Edmichael Joil D",
        "Gelacio, Samuel Allen L",
        "Liwanag, Phoebe Kelly C"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "",
      "initiatedOn": "2025-09-08 07:29",
      "category": "",
      "primaryTechStack": [],
      "technology": [
        "Grafana",
        " Influx",
        " ETL"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "146",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "12-7-2025",
          "expiresAt": "12-21-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "4-21-2025",
          "expiresAt": "10-21-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "8-15-2025",
          "expiresAt": "11-17-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Telemetry",
      "engagement": "R&D",
      "modified": "2025-11-05 07:41",
      "subBU": "CAMS",
      "priority": "Critical",
      "assignee": [
        "Panela, Jewel Anne B",
        "Naidas, John Marie L",
        "Madarang, Andrea Yna M",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Frank",
      "initiatedOn": "2024-08-31 18:00",
      "category": "[\"AI, Automation, Integration\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "1",
      "estimates": "",
      "dueOn": "",
      "id": "30",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "3-2-2025",
          "expiresAt": "3-28-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "gallery": [
        {
          "src": "/assets/img/gallery/telemetry/dashboard.png",
          "caption": "Dashboard"
        },
        {
          "src": "/assets/img/gallery/telemetry/executive_view.png",
          "caption": "Dashboard - Executive View"
        },
        {
          "src": "/assets/img/gallery/telemetry/back_office_command_centre.png",
          "caption": "Back Office Command Centre"
        }
      ],
      "isVisible": true
    },
    {
      "title": "Bulk Upload",
      "engagement": "EPOS",
      "modified": "2025-11-05 07:37",
      "subBU": "EUSS",
      "priority": "High",
      "assignee": [
        "Batula, John Michael M",
        "Pangindian, Ramher N",
        "Morallos, Ruth R",
        "Giba, Mark Gerald P"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Gratz",
      "initiatedOn": "2024-06-30 18:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [
        "Selenium"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "2025-06-21",
      "id": "24",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "10-17-2025",
          "expiresAt": "11-28-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "4-22-2025",
          "expiresAt": "8-27-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "6-3-2025",
          "expiresAt": "7-3-2025"
        },
        {
          "name": "Access 4",
          "grantedOn": "6-14-2025",
          "expiresAt": "7-25-2026"
        },
        {
          "name": "Access 5",
          "grantedOn": "1-3-2025",
          "expiresAt": "4-14-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Agentic Knowledge Assistant",
      "engagement": "Valmet",
      "modified": "2025-10-28 08:46",
      "subBU": "EUSS",
      "priority": "High",
      "assignee": [
        "Batas, Jennie Lyn C",
        "Legaspi, Rosuello Vincent A",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Manel",
      "initiatedOn": "2025-05-06 18:00",
      "category": "[\"AI\",\"Integration\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "Reserved_ImageAttachment_[29]_[High_x0020_Level_x0020_Design][32]_[c055e24e7d48479ca8c79383376a22a7][2]_[41].png",
      "wireframes": "https://groupecgi-my.sharepoint.com/:i:/r/personal/frank_katadajr_cgi_com/Documents/All%20Queue/Image/image.png",
      "attachments": "1",
      "estimates": "https://groupecgi-my.sharepoint.com/:x:/r/personal/frank_katadajr_cgi_com/Documents/AI%20Internal%20Docs/Estimates/VALMET%20-%20KB%20Instructed%20Assistive%20Agent%20-%20Estimate%20-%20v2.4.xlsx?d=we30e5ea1b333407385a1d66c1ebeaf8c&csf=1&web=1&e=5N6ZUI",
      "dueOn": "2025-06-05",
      "id": "1",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "8-7-2025",
          "expiresAt": "10-10-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "9-9-2025",
          "expiresAt": "11-11-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "12-17-2025",
          "expiresAt": "12-25-2026"
        },
        {
          "name": "Access 4",
          "grantedOn": "4-5-2025",
          "expiresAt": "11-27-2025"
        },
        {
          "name": "Access 5",
          "grantedOn": "4-18-2025",
          "expiresAt": "11-28-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Rituals Roadmap",
      "engagement": "Rituals",
      "modified": "2025-10-28 08:43",
      "subBU": "EUSS",
      "priority": "High",
      "assignee": [
        "Hizon, Genrev Kiel A",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "NEW",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "",
      "initiatedOn": "2025-10-06 07:53",
      "category": "",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "149",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "9-5-2025",
          "expiresAt": "12-18-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "4-4-2025",
          "expiresAt": "8-18-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "5-22-2025",
          "expiresAt": "6-25-2027"
        },
        {
          "name": "Access 4",
          "grantedOn": "7-28-2025",
          "expiresAt": "8-30-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Telemetry - PILOT (SSAB)",
      "engagement": "SSAB",
      "modified": "2025-10-20 07:31",
      "subBU": "EUSS",
      "priority": "Critical",
      "assignee": [
        "Panela, Jewel Anne B",
        "Naidas, John Marie L",
        "Katada Jr., Frank P",
        "Madarang, Andrea Yna M"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Paul",
      "initiatedOn": "2024-11-04 17:00",
      "category": "[\"AI, Automation, Integration\",\"IoT\"]",
      "primaryTechStack": [
        "Observability"
      ],
      "technology": [
        "OpenTelemetry"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "9",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "8-16-2025",
          "expiresAt": "11-21-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Translation Tool FrEn D365 Fo",
      "engagement": "Aspen",
      "modified": "2025-10-06 08:03",
      "subBU": "ERP",
      "priority": "Medium",
      "assignee": [
        "Legaspi, Rosuello Vincent A",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Cuerdo, Charisse <charisse.cuerdo@cgi.com>",
      "initiatedOn": "2025-08-06 18:59",
      "category": "[\"AI\",\"Integration\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "141",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "3-19-2025",
          "expiresAt": "5-26-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Web Automation and IVR",
      "engagement": "Shell",
      "modified": "2025-10-06 07:55",
      "subBU": "CAMS",
      "priority": "High",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "Bids",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Ron",
      "initiatedOn": "2025-07-08 15:20",
      "category": "",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "2025-07-10",
      "id": "138",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "6-24-2025",
          "expiresAt": "11-25-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "7-22-2025",
          "expiresAt": "10-26-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "10-25-2025",
          "expiresAt": "10-29-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "FI Controllership - Monthly IPS & Forecasting",
      "engagement": "GHRMS",
      "modified": "2025-10-06 07:27",
      "subBU": "GBS",
      "priority": "Low",
      "assignee": [
        "Giba, Mark Gerald P",
        "Liwanag, Phoebe Kelly C"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "FI",
      "initiatedOn": "2025-09-16 19:01",
      "category": "[\"Automation\"]",
      "primaryTechStack": [
        "Web",
        " Python"
      ],
      "technology": [
        "Playwright",
        " Numpy",
        " Pandas"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "147",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "4-17-2025",
          "expiresAt": "6-28-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "AWS Connect - CXone with Az-speech",
      "engagement": "Silvia",
      "modified": "2025-10-02 15:09",
      "subBU": "BU",
      "priority": "High",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Miss Jill",
      "initiatedOn": "2024-12-08 17:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "2025-10-31",
      "id": "20",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "6-29-2025",
          "expiresAt": "6-30-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "QA Audit - Agentic - Teams Embedded  POC",
      "engagement": "BMo",
      "modified": "2025-10-01 11:37",
      "subBU": "EUSS",
      "priority": "High",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Miss Pauline",
      "initiatedOn": "2024-07-30 18:00",
      "category": "[\"AI\",\"Automation\",\"Fullstack\"]",
      "primaryTechStack": [
        "Microsoft 365",
        " ServiceNow",
        " AWS",
        " Python",
        " React"
      ],
      "technology": [
        "Teams Application Development"
      ],
      "highLevelDesign": "Reserved_ImageAttachment_[29]_[High_x0020_Level_x0020_Design][32]_[d75931ca63c740709e9a3fb6dbcbff81][2]_[38].png",
      "wireframes": "",
      "attachments": "1",
      "estimates": "",
      "dueOn": "",
      "id": "17",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "6-11-2025",
          "expiresAt": "11-11-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "4-13-2025",
          "expiresAt": "12-21-2026"
        }
      ],
      "gallery": [
        {
          "src": "/assets/img/gallery/qa-ss/login.jpg",
          "caption": "Login"
        },
        {
          "src": "/assets/img/gallery/qa-ss/dashboard.jpg",
          "caption": "Dashboard"
        },
        {
          "src": "/assets/img/gallery/qa-ss/audit.jpg",
          "caption": "Audit Page"
        },
        {
          "src": "/assets/img/gallery/qa-ss/audit_form.jpg",
          "caption": "Audit Page - Form"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Phase 1-3 - Document Owner Classification, Naming Standard and Organization",
      "engagement": "EPOS",
      "modified": "2025-09-29 07:46",
      "subBU": "EUSS",
      "priority": "High",
      "assignee": [
        "Batula, John Michael M",
        "Pangindian, Ramher N",
        "Morallos, Ruth R",
        "Giba, Mark Gerald P"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Gratz",
      "initiatedOn": "2024-01-14 18:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [
        "Azure",
        " Microsoft 365",
        " Python"
      ],
      "technology": [
        "AZ Vision OCR",
        " SharePoint"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "25",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "2-18-2025",
          "expiresAt": "7-27-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "SP Migration - Phase 4",
      "engagement": "EPOS",
      "modified": "2025-09-29 07:46",
      "subBU": "EUSS",
      "priority": "High",
      "assignee": [
        "Batula, John Michael M",
        "Pangindian, Ramher N",
        "Morallos, Ruth R",
        "Giba, Mark Gerald P",
        "Valbuena, Gabrielle Rheana Marie R"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Gratz",
      "initiatedOn": "2024-03-24 17:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [
        "Microsoft 365",
        " Azure",
        " Python"
      ],
      "technology": [
        "SharePoint"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "26",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "3-12-2025",
          "expiresAt": "3-26-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "2-20-2025",
          "expiresAt": "6-30-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "FrEn Browser Extension",
      "engagement": "LVMH",
      "modified": "2025-09-29 07:44",
      "subBU": "CAMS",
      "priority": "Medium",
      "assignee": [
        "Katada Jr., Frank P",
        "Legaspi, Rosuello Vincent A"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "anna.onate@cgi.com",
      "initiatedOn": "2025-08-13 08:17",
      "category": "",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "143",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "4-17-2025",
          "expiresAt": "9-17-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "7-25-2025",
          "expiresAt": "9-27-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "12-4-2025",
          "expiresAt": "12-8-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Macro Extraction",
      "engagement": "CI Fin",
      "modified": "2025-09-29 07:42",
      "subBU": "CBPS",
      "priority": "High",
      "assignee": [
        "Laxa, Hannah Franchette",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "",
      "initiatedOn": "2025-05-22 00:00",
      "category": "[\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "132",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "9-23-2025",
          "expiresAt": "9-30-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "7-10-2025",
          "expiresAt": "11-12-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "7-16-2025",
          "expiresAt": "7-17-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "FI Finance - GL & DelRev Automation",
      "engagement": "GHRMS",
      "modified": "2025-09-16 18:58",
      "subBU": "GBS",
      "priority": "Low",
      "assignee": [
        "Aguas, Nathanael Jhonn R",
        "Giba, Mark Gerald P",
        "Morallos, Ruth R"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "FI",
      "initiatedOn": "2024-04-02 18:00",
      "category": "[\"Automation\"]",
      "primaryTechStack": [
        "Web Drivers",
        " Python"
      ],
      "technology": [
        "Playwright",
        " Numpy",
        " Pandas"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "1",
      "estimates": "",
      "dueOn": "",
      "id": "61",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "8-23-2025",
          "expiresAt": "8-23-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "12-26-2025",
          "expiresAt": "12-30-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "9-26-2025",
          "expiresAt": "9-29-2025"
        },
        {
          "name": "Access 4",
          "grantedOn": "10-18-2025",
          "expiresAt": "10-27-2027"
        },
        {
          "name": "Access 5",
          "grantedOn": "11-17-2025",
          "expiresAt": "12-21-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Teams and Power Platform Assessment",
      "engagement": "Sandvik",
      "modified": "2025-09-16 11:00",
      "subBU": "ERP",
      "priority": "High",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "Advisor",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Ronald",
      "initiatedOn": "2024-07-05 18:00",
      "category": "[\"AI, Automation, Fullstack, Integration\"]",
      "primaryTechStack": [
        "Microsoft 365",
        " Azure"
      ],
      "technology": [
        "Teams Virtual Agent",
        "Teams Tab Application"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "2025-05-19",
      "id": "7",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "5-3-2025",
          "expiresAt": "8-10-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "11-16-2025",
          "expiresAt": "11-20-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "7-23-2025",
          "expiresAt": "10-28-2025"
        },
        {
          "name": "Access 4",
          "grantedOn": "7-29-2025",
          "expiresAt": "10-29-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "ProperPay:  ICU-DRG",
      "engagement": "KPO",
      "modified": "2025-09-09 18:26",
      "subBU": "CBPS",
      "priority": "Medium",
      "assignee": [
        "Rodriguez, Alec Justin"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Miss Tess, Caparas, Ma. Victoria",
      "initiatedOn": "2024-11-07 17:00",
      "category": "[\"AI, Automation, Integration\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "53",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "2-1-2025",
          "expiresAt": "11-4-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "AZ-Speech AWS Connect - Azure Speech",
      "engagement": "Internal",
      "modified": "2025-09-09 18:26",
      "subBU": "BU",
      "priority": "Medium",
      "assignee": [
        "Valbuena, Gabrielle Rheana Marie R",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Miss Jill",
      "initiatedOn": "2024-12-11 17:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [
        "Azure",
        " AWS",
        " Python"
      ],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "29",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "1-14-2025",
          "expiresAt": "12-25-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "3-19-2025",
          "expiresAt": "3-19-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "9-14-2025",
          "expiresAt": "11-22-2027"
        },
        {
          "name": "Access 4",
          "grantedOn": "5-9-2025",
          "expiresAt": "10-20-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Audit and Coaching",
      "engagement": "Shared Service",
      "modified": "2025-09-09 10:05",
      "subBU": "CAMS",
      "priority": "High",
      "assignee": [
        "Madarang, Andrea Yna M"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "IDA",
      "initiatedOn": "2024-10-22 18:00",
      "category": "[\"AI\",\"Automation\",\"Fullstack\"]",
      "primaryTechStack": [
        "Microsoft 365",
        " ServiceNow",
        " AWS",
        " Python",
        " React"
      ],
      "technology": [
        "Teams Application Development"
      ],
      "highLevelDesign": "Reserved_ImageAttachment_[29]_[High_x0020_Level_x0020_Design][32]_[2eed59c83d574b21a240c47d274b6cd6][2]_[21].svg",
      "wireframes": "",
      "attachments": "1",
      "estimates": "",
      "dueOn": "2025-07-08",
      "id": "4",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "11-14-2025",
          "expiresAt": "12-18-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "1-28-2025",
          "expiresAt": "3-30-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "CI FIN Re-Discovery",
      "engagement": "CI Fin",
      "modified": "2025-09-09 10:05",
      "subBU": "CBPS",
      "priority": "High",
      "assignee": [
        "Aguas, Nathanael Jhonn R"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Completed",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Jonathan Chavez, Ron",
      "initiatedOn": "2024-11-18 17:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "2025-06-16",
      "id": "13",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "9-6-2025",
          "expiresAt": "10-17-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "10-18-2025",
          "expiresAt": "12-18-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "4-5-2025",
          "expiresAt": "9-19-2025"
        },
        {
          "name": "Access 4",
          "grantedOn": "10-16-2025",
          "expiresAt": "11-25-2026"
        },
        {
          "name": "Access 5",
          "grantedOn": "12-16-2025",
          "expiresAt": "12-20-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "BMO TPS - Ticket Dump",
      "engagement": "BMo",
      "modified": "2025-09-09 10:05",
      "subBU": "EUSS",
      "priority": "Medium",
      "assignee": [
        "Fajardo, Edmichael Joil D",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Completed",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "EUSS",
      "initiatedOn": "2025-05-06 00:00",
      "category": "[\"AI\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "2025-05-08",
      "id": "129",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "8-20-2025",
          "expiresAt": "10-24-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "4-5-2025",
          "expiresAt": "8-15-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "5-14-2025",
          "expiresAt": "5-28-2027"
        },
        {
          "name": "Access 4",
          "grantedOn": "6-7-2025",
          "expiresAt": "10-22-2026"
        },
        {
          "name": "Access 5",
          "grantedOn": "12-4-2025",
          "expiresAt": "12-16-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Predicting Security Incident",
      "engagement": "Valmet",
      "modified": "2025-09-09 07:47",
      "subBU": "EUSS",
      "priority": "High",
      "assignee": [
        "Hizon, Genrev Kiel A"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Manel",
      "initiatedOn": "2024-12-08 17:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [
        "Azure",
        " ServiceNow",
        " Python"
      ],
      "technology": [
        "Classification"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "28",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "7-18-2025",
          "expiresAt": "7-28-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "3-16-2025",
          "expiresAt": "10-26-2026"
        },
        {
          "name": "Access 3",
          "grantedOn": "11-8-2025",
          "expiresAt": "11-27-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "PFL eligibility and calculation",
      "engagement": "HRBP",
      "modified": "2025-09-08 07:43",
      "subBU": "BU",
      "priority": "High",
      "assignee": [
        "Fajardo, Edmichael Joil D"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Completed",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Miss Bheng",
      "initiatedOn": "2025-09-02 10:41",
      "category": "",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "145",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "12-5-2025",
          "expiresAt": "12-25-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "4-20-2025",
          "expiresAt": "12-29-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "9-1-2025",
          "expiresAt": "10-7-2027"
        },
        {
          "name": "Access 4",
          "grantedOn": "5-15-2025",
          "expiresAt": "9-20-2027"
        },
        {
          "name": "Access 5",
          "grantedOn": "3-28-2025",
          "expiresAt": "6-28-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Phase 1 - Migration + Real-Time Audio I/O, Response and Avatar ",
      "engagement": "FIBA",
      "modified": "2025-08-14 15:47",
      "subBU": "EUSS",
      "priority": "Low",
      "assignee": [
        "D&AS Embedded Analytics Security Group",
        "Katada Jr., Frank P",
        "Hizon, Genrev Kiel A",
        "Batula, John Michael M",
        "Aguas, Nathanael Jhonn R",
        "Valbuena, Gabrielle Rheana Marie R",
        "Ware, Angelica P"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Pertti",
      "initiatedOn": "2024-04-01 18:00",
      "category": "[\"AI, Automation, Fullstack, Integration\"]",
      "primaryTechStack": [
        "Azure",
        " Python",
        " ReactTS"
      ],
      "technology": [
        "AZ Speech",
        " AZ Translate",
        " AZ Language",
        " AZ OpenAI",
        " Flask",
        " MUI"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "99",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "2-26-2025",
          "expiresAt": "4-26-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "QA Ops ",
      "engagement": "",
      "modified": "2025-08-11 13:33",
      "subBU": "Internal",
      "priority": "Medium",
      "assignee": [
        "Madarang, Andrea Yna M"
      ],
      "workType": "Admin",
      "status": "NEW",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Zel",
      "initiatedOn": "2025-08-11 13:25",
      "category": "",
      "primaryTechStack": [
        "ReactJS"
      ],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "142",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "4-29-2025",
          "expiresAt": "12-29-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "9-17-2025",
          "expiresAt": "10-30-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "6-25-2025",
          "expiresAt": "6-30-2026"
        },
        {
          "name": "Access 4",
          "grantedOn": "4-21-2025",
          "expiresAt": "5-21-2026"
        },
        {
          "name": "Access 5",
          "grantedOn": "10-27-2025",
          "expiresAt": "10-28-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "GBS Mailer to Assignment Groups",
      "engagement": "GBS",
      "modified": "2025-08-11 08:36",
      "subBU": "BU",
      "priority": "Medium",
      "assignee": [
        "Katada Jr., Frank P",
        "Pangindian, Ramher N",
        "Catley, Jacqueline Cate S"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Ron, Dream",
      "initiatedOn": "2025-04-10 18:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "16",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "12-19-2025",
          "expiresAt": "12-28-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "7-17-2025",
          "expiresAt": "11-22-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "4-23-2025",
          "expiresAt": "8-23-2026"
        },
        {
          "name": "Access 4",
          "grantedOn": "5-10-2025",
          "expiresAt": "12-30-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "GBS POC WSE",
      "engagement": "GBS",
      "modified": "2025-08-06 07:03",
      "subBU": "",
      "priority": "Medium",
      "assignee": [
        "Catley, Jacqueline Cate S"
      ],
      "workType": "R&D",
      "status": "NEW",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Karla",
      "initiatedOn": "2025-08-06 07:02",
      "category": "[\"AI\",\"Automation\",\"Integration\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "139",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "10-12-2025",
          "expiresAt": "11-24-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "8-24-2025",
          "expiresAt": "11-29-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "GBS DEF - (similar to EPOS)",
      "engagement": "GBS",
      "modified": "2025-08-06 04:55",
      "subBU": "GBS",
      "priority": "Medium",
      "assignee": [
        "Katada Jr., Frank P",
        "Pangindian, Ramher N"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Ron, Dream",
      "initiatedOn": "2025-04-10 18:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "15",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "3-11-2025",
          "expiresAt": "7-21-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "2-11-2025",
          "expiresAt": "7-28-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "11-10-2025",
          "expiresAt": "12-16-2025"
        },
        {
          "name": "Access 4",
          "grantedOn": "8-21-2025",
          "expiresAt": "11-22-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Phase 2 - Additional Forms and Templates",
      "engagement": "ProperPay",
      "modified": "2025-07-17 16:30",
      "subBU": "CAMS",
      "priority": "Low",
      "assignee": [
        "Hizon, Genrev Kiel A"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Miss Lolit",
      "initiatedOn": "2024-04-07 18:00",
      "category": "[\"Fullstack\"]",
      "primaryTechStack": [
        "Python",
        " ReactTS"
      ],
      "technology": [
        "Flask",
        " MUI"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "105",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "4-2-2025",
          "expiresAt": "5-18-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "1-19-2025",
          "expiresAt": "3-27-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "5-16-2025",
          "expiresAt": "8-25-2027"
        },
        {
          "name": "Access 4",
          "grantedOn": "8-24-2025",
          "expiresAt": "9-28-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "EPOS for NL (once Germany is Completed)",
      "engagement": "EPOS",
      "modified": "2025-07-17 16:29",
      "subBU": "EUSS",
      "priority": "Medium",
      "assignee": [
        "Pangindian, Ramher N"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Completed",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Gratz",
      "initiatedOn": "2024-06-30 18:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [
        "Selenium"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "23",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "11-21-2025",
          "expiresAt": "11-25-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "11-22-2025",
          "expiresAt": "11-23-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "5-24-2025",
          "expiresAt": "12-28-2026"
        },
        {
          "name": "Access 4",
          "grantedOn": "7-25-2025",
          "expiresAt": "10-27-2025"
        },
        {
          "name": "Access 5",
          "grantedOn": "7-24-2025",
          "expiresAt": "11-26-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "AMS",
      "engagement": "Greater Montreal",
      "modified": "2025-07-17 16:29",
      "subBU": "ERP",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "Bids",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Stephen",
      "initiatedOn": "2024-06-12 18:00",
      "category": "[\"AI, Automation, Integration\"]",
      "primaryTechStack": [
        "Power Plaform"
      ],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "59",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "7-22-2025",
          "expiresAt": "7-22-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Members R&R ",
      "engagement": "Internal",
      "modified": "2025-07-17 16:19",
      "subBU": "CAMS",
      "priority": "Low",
      "assignee": [
        "Pulido, Marc Joseph"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Boss Ron",
      "initiatedOn": "2024-01-05 16:19",
      "category": "[\"AI, Automation, Fullstack, IoT\"]",
      "primaryTechStack": [
        "Power Platform",
        " Python",
        " ReactTS"
      ],
      "technology": [
        "Face Detection and Recognition",
        " Tensorflow",
        " Flask",
        " MySQL"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "107",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "1-20-2025",
          "expiresAt": "2-30-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "10-5-2025",
          "expiresAt": "11-8-2026"
        },
        {
          "name": "Access 3",
          "grantedOn": "11-4-2025",
          "expiresAt": "11-19-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Hybrid Arcitecture",
      "engagement": "Internal",
      "modified": "2025-07-17 16:16",
      "subBU": "CAMS",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Boss Ron",
      "initiatedOn": "2022-07-31 18:00",
      "category": "[\"Fullstack\"]",
      "primaryTechStack": [
        "Azure"
      ],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "125",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "4-17-2025",
          "expiresAt": "12-20-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Voice Virtual Agent - Google Conversational AI",
      "engagement": "R&D",
      "modified": "2025-07-17 16:13",
      "subBU": "EUSS",
      "priority": "Low",
      "assignee": [
        "Hizon, Genrev Kiel A"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "EUSS",
      "initiatedOn": "2024-03-14 17:00",
      "category": "[\"AI, Automation, Fullstack, Integration\"]",
      "primaryTechStack": [
        "GCP",
        " Python"
      ],
      "technology": [
        "Flask"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "97",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "9-1-2025",
          "expiresAt": "10-30-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "7-14-2025",
          "expiresAt": "9-20-2026"
        },
        {
          "name": "Access 3",
          "grantedOn": "5-4-2025",
          "expiresAt": "5-14-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "CXOne and RT AZ Speech",
      "engagement": "R&D",
      "modified": "2025-07-17 16:13",
      "subBU": "EUSS",
      "priority": "Medium",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Paul",
      "initiatedOn": "2024-11-04 17:00",
      "category": "[\"AI, Automation, Integration\"]",
      "primaryTechStack": [
        "Azure",
        " CXOne",
        " W3C",
        " Python",
        " TypeScript"
      ],
      "technology": [
        "WebRTC"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "19",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "4-15-2025",
          "expiresAt": "4-18-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "12-24-2025",
          "expiresAt": "12-29-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "5-5-2025",
          "expiresAt": "6-17-2027"
        },
        {
          "name": "Access 4",
          "grantedOn": "10-3-2025",
          "expiresAt": "10-9-2027"
        },
        {
          "name": "Access 5",
          "grantedOn": "9-16-2025",
          "expiresAt": "12-23-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Pandas AI",
      "engagement": "R&D",
      "modified": "2025-07-17 16:13",
      "subBU": "CAMS",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Frank",
      "initiatedOn": "2024-10-07 18:00",
      "category": "[\"AI, Automation, Fullstack\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "69",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "10-28-2025",
          "expiresAt": "10-30-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "UW Indexing",
      "engagement": "Mapfre",
      "modified": "2025-07-17 16:13",
      "subBU": "CBPS",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Completed",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Peter Pormixelle",
      "initiatedOn": "2024-01-15 17:00",
      "category": "[\"AI, Automation\"]",
      "primaryTechStack": [
        "OCR",
        "RPA"
      ],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "104",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "12-21-2025",
          "expiresAt": "12-21-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "CBPS - Coaching Log & QA Form - Potential PowerApps Use Case Discussion",
      "engagement": "CI Fin",
      "modified": "2025-07-17 16:12",
      "subBU": "CBPS",
      "priority": "Medium",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Chavez, Divina Florence P",
      "initiatedOn": "2025-05-05 00:00",
      "category": "[\"Fullstack\",\"Business Intelligence\",\"Integration\",\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "2025-05-06",
      "id": "128",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "3-29-2025",
          "expiresAt": "5-29-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "10-2-2025",
          "expiresAt": "10-17-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "PI's for Daniel",
      "engagement": "Valmet",
      "modified": "2025-07-17 16:12",
      "subBU": "EUSS",
      "priority": "Medium",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "NEW",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "",
      "initiatedOn": "2025-06-13 00:00",
      "category": "",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "2025-06-16",
      "id": "133",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "5-1-2025",
          "expiresAt": "9-26-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "4-11-2025",
          "expiresAt": "9-14-2026"
        },
        {
          "name": "Access 3",
          "grantedOn": "4-23-2025",
          "expiresAt": "8-23-2027"
        },
        {
          "name": "Access 4",
          "grantedOn": "10-24-2025",
          "expiresAt": "10-26-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Browser Extension: DocumentScan",
      "engagement": "R&D",
      "modified": "2025-07-17 16:12",
      "subBU": "CAMS",
      "priority": "Medium",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Frank",
      "initiatedOn": "2025-04-09 18:00",
      "category": "[\"Automation\",\"Integration\"]",
      "primaryTechStack": [
        "W3C"
      ],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "2025-06-23",
      "id": "5",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "12-25-2025",
          "expiresAt": "12-25-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "1-24-2025",
          "expiresAt": "7-25-2026"
        },
        {
          "name": "Access 3",
          "grantedOn": "9-14-2025",
          "expiresAt": "11-30-2025"
        },
        {
          "name": "Access 4",
          "grantedOn": "2-4-2025",
          "expiresAt": "7-20-2026"
        },
        {
          "name": "Access 5",
          "grantedOn": "10-26-2025",
          "expiresAt": "12-28-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Valmet ServiceNow KB Conversational VA with- Swedish translation",
      "engagement": "Valmet",
      "modified": "2025-07-17 16:12",
      "subBU": "EUSS",
      "priority": "Medium",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "Advisor",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Pertti",
      "initiatedOn": "2025-03-13 17:00",
      "category": "[\"AI, Automation, Fullstack\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "22",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "7-24-2025",
          "expiresAt": "7-24-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Equinor Usecase Discovery by Data",
      "engagement": "Equinor",
      "modified": "2025-07-17 16:12",
      "subBU": "EUSS",
      "priority": "High",
      "assignee": [
        "Fajardo, Edmichael Joil D"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Paul",
      "initiatedOn": "2025-03-16 17:00",
      "category": "[\"AI\",\"Integration\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "3",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "8-10-2025",
          "expiresAt": "10-27-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Visitor Log",
      "engagement": "FASH",
      "modified": "2025-07-17 16:04",
      "subBU": "BU",
      "priority": "Low",
      "assignee": [
        "Pulido, Marc Joseph"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Boss Ron",
      "initiatedOn": "2024-03-14 17:00",
      "category": "[\"AI, Automation, Fullstack\"]",
      "primaryTechStack": [
        "Power Platform",
        " Python",
        " ReactTS"
      ],
      "technology": [
        "PowerBI",
        " Flask",
        " MUI"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "94",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "12-21-2025",
          "expiresAt": "12-30-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "10-9-2025",
          "expiresAt": "11-26-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "12-18-2025",
          "expiresAt": "12-20-2027"
        },
        {
          "name": "Access 4",
          "grantedOn": "1-22-2025",
          "expiresAt": "5-26-2026"
        },
        {
          "name": "Access 5",
          "grantedOn": "1-20-2025",
          "expiresAt": "6-29-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Image to 3D",
      "engagement": "Internal",
      "modified": "2025-07-17 16:04",
      "subBU": "BU",
      "priority": "Low",
      "assignee": [
        "Pulido, Marc Joseph"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Boss Ron",
      "initiatedOn": "2024-06-19 18:00",
      "category": "[\"AI, Automation\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "100",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "10-7-2025",
          "expiresAt": "11-12-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "1-14-2025",
          "expiresAt": "9-30-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "3-22-2025",
          "expiresAt": "3-24-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "ITSM - Predictive Analytics - Localized Model",
      "engagement": "BU",
      "modified": "2025-07-17 16:04",
      "subBU": "CAMS",
      "priority": "Low",
      "assignee": [
        "Pulido, Marc Joseph"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Boss Ron",
      "initiatedOn": "2024-03-14 17:00",
      "category": "[\"AI\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [
        "Time-series forecasting"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "86",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "7-15-2025",
          "expiresAt": "9-24-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "4-20-2025",
          "expiresAt": "6-24-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "4-11-2025",
          "expiresAt": "8-25-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Localized Custom Token Classification ",
      "engagement": "R&D",
      "modified": "2025-07-17 16:04",
      "subBU": "BU",
      "priority": "Low",
      "assignee": [
        "Pulido, Marc Joseph"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Frank",
      "initiatedOn": "2024-03-14 17:00",
      "category": "[\"AI\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [
        "Exploratory Data Analysis",
        " Jupyter",
        " AI Modeling"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "87",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "6-15-2025",
          "expiresAt": "12-15-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "10-27-2025",
          "expiresAt": "12-27-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "2-29-2025",
          "expiresAt": "7-29-2025"
        },
        {
          "name": "Access 4",
          "grantedOn": "3-21-2025",
          "expiresAt": "11-27-2026"
        },
        {
          "name": "Access 5",
          "grantedOn": "9-7-2025",
          "expiresAt": "12-16-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Sentiment Analysis - Localized Model - Infeedo Like",
      "engagement": "R&D",
      "modified": "2025-07-17 16:04",
      "subBU": "CAMS",
      "priority": "Low",
      "assignee": [
        "Pulido, Marc Joseph"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Boss Ron",
      "initiatedOn": "2024-03-14 17:00",
      "category": "[\"AI\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [
        "Exploratory Data Analysis",
        " Jupyter",
        " AI Modeling"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "93",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "12-3-2025",
          "expiresAt": "12-7-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Automatic Speech Recognition - Speech to Text ",
      "engagement": "R&D",
      "modified": "2025-07-17 16:02",
      "subBU": "EUSS",
      "priority": "Low",
      "assignee": [
        "D&AS Embedded Analytics Security Group"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "EUSS",
      "initiatedOn": "2024-02-05 17:00",
      "category": "[\"AI\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [
        "Tensorflow"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "109",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "2-13-2025",
          "expiresAt": "6-21-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Speech Translation Model",
      "engagement": "R&D",
      "modified": "2025-07-17 16:02",
      "subBU": "EUSS",
      "priority": "Low",
      "assignee": [
        "D&AS Embedded Analytics Security Group"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "EUSS",
      "initiatedOn": "2024-02-05 17:00",
      "category": "[\"AI\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [
        "PyTorch",
        " Sequence to Sequence Model"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "110",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "12-12-2025",
          "expiresAt": "12-20-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Text Synthesis - Text to Speech",
      "engagement": "R&D",
      "modified": "2025-07-17 16:02",
      "subBU": "EUSS",
      "priority": "Low",
      "assignee": [
        "D&AS Embedded Analytics Security Group"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "EUSS",
      "initiatedOn": "2024-02-05 17:00",
      "category": "[\"AI\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [
        "Tensorflow"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "111",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "10-14-2025",
          "expiresAt": "10-18-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "5-1-2025",
          "expiresAt": "12-5-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "5-12-2025",
          "expiresAt": "10-14-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Service Now Limitation Usecases",
      "engagement": "Valmet",
      "modified": "2025-07-17 16:02",
      "subBU": "EUSS",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "Advisor",
      "status": "DUPLICATE",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Manel",
      "initiatedOn": "2024-06-02 18:00",
      "category": "[\"AI, Automation, Fullstack, Integration\"]",
      "primaryTechStack": [
        "ServiceNow"
      ],
      "technology": [
        "Alignment from Valmet AI pipeline and Workshop Identified. Returned to D&AS due to Service Now Limitations"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "34",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "6-6-2025",
          "expiresAt": "9-15-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "1-10-2025",
          "expiresAt": "8-19-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "3-3-2025",
          "expiresAt": "3-12-2026"
        },
        {
          "name": "Access 4",
          "grantedOn": "11-19-2025",
          "expiresAt": "12-21-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Remote Deposit",
      "engagement": "BMo",
      "modified": "2025-07-17 16:02",
      "subBU": "EUSS",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Miss Pauline",
      "initiatedOn": "2024-07-30 18:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "44",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "7-13-2025",
          "expiresAt": "8-26-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "2-13-2025",
          "expiresAt": "3-16-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Contract Management",
      "engagement": "R&D",
      "modified": "2025-07-17 16:00",
      "subBU": "BU",
      "priority": "Low",
      "assignee": [
        "Madarang, Andrea Yna M"
      ],
      "workType": "Admin",
      "status": "NEW",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "",
      "initiatedOn": "2025-07-14 15:22",
      "category": "[\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "2025-07-04",
      "id": "137",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "1-10-2025",
          "expiresAt": "7-13-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "3-10-2025",
          "expiresAt": "10-13-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "DFS",
      "engagement": "KPO",
      "modified": "2025-07-17 15:59",
      "subBU": "CBPS",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Completed",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Miss Tess, Cindy",
      "initiatedOn": "2024-11-14 17:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "52",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "10-11-2025",
          "expiresAt": "11-25-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "4-28-2025",
          "expiresAt": "4-29-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "KPO-FRES",
      "engagement": "KPO",
      "modified": "2025-07-17 15:59",
      "subBU": "CBPS",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Miss Tess, Cindy",
      "initiatedOn": "2024-11-14 17:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "55",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "4-2-2025",
          "expiresAt": "4-22-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "3-10-2025",
          "expiresAt": "5-26-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "10-15-2025",
          "expiresAt": "11-20-2026"
        },
        {
          "name": "Access 4",
          "grantedOn": "6-29-2025",
          "expiresAt": "11-29-2025"
        },
        {
          "name": "Access 5",
          "grantedOn": "4-25-2025",
          "expiresAt": "10-25-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "KB VA Enhancement - Swedish ",
      "engagement": "Valmet",
      "modified": "2025-07-17 15:59",
      "subBU": "EUSS",
      "priority": "High",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "Advisor",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Pertti",
      "initiatedOn": "2025-04-21 18:00",
      "category": "[\"AI\",\"Integration\",\"Fullstack\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "2",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "4-19-2025",
          "expiresAt": "7-26-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "AT&T Contract Management",
      "engagement": "AT&T",
      "modified": "2025-07-17 15:59",
      "subBU": "CBPS",
      "priority": "Medium",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Sam O",
      "initiatedOn": "2024-11-21 17:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "12",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "10-16-2025",
          "expiresAt": "10-28-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "AI/Automation for HR NTE",
      "engagement": "EUSS",
      "modified": "2025-07-17 15:59",
      "subBU": "EUSS",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Paul/Manu",
      "initiatedOn": "2024-10-24 18:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "40",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "2-16-2025",
          "expiresAt": "3-17-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "8-17-2025",
          "expiresAt": "9-27-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "1-13-2025",
          "expiresAt": "12-23-2026"
        },
        {
          "name": "Access 4",
          "grantedOn": "9-27-2025",
          "expiresAt": "10-29-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "TTS (Text-to-speech) feature for KBA",
      "engagement": "Valmet",
      "modified": "2025-07-17 15:58",
      "subBU": "EUSS",
      "priority": "Low",
      "assignee": [
        "Hizon, Genrev Kiel A",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Manel, Keo",
      "initiatedOn": "2024-10-09 18:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "31",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "7-29-2025",
          "expiresAt": "12-29-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "1-1-2025",
          "expiresAt": "4-20-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "6-5-2025",
          "expiresAt": "11-20-2025"
        },
        {
          "name": "Access 4",
          "grantedOn": "11-21-2025",
          "expiresAt": "12-27-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Enhancement of Prod Teams Virtual Agent",
      "engagement": "Valmet",
      "modified": "2025-07-17 15:58",
      "subBU": "EUSS",
      "priority": "Low",
      "assignee": [
        "Hizon, Genrev Kiel A",
        "Katada Jr., Frank P"
      ],
      "workType": "Advisor",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Manel",
      "initiatedOn": "2024-11-27 17:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "39",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "6-18-2025",
          "expiresAt": "7-21-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "ProperPay SST and Semantic Search",
      "engagement": "KPO",
      "modified": "2025-07-17 15:57",
      "subBU": "CBPS",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P",
        "Aguas, Nathanael Jhonn R"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Miss Tess, Caparas, Ma. Victoria",
      "initiatedOn": "2024-11-07 17:00",
      "category": "[\"AI, Automation, Integration\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "54",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "8-26-2025",
          "expiresAt": "12-26-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "1-29-2025",
          "expiresAt": "9-29-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "7-12-2025",
          "expiresAt": "11-25-2025"
        },
        {
          "name": "Access 4",
          "grantedOn": "1-15-2025",
          "expiresAt": "9-19-2026"
        },
        {
          "name": "Access 5",
          "grantedOn": "2-20-2025",
          "expiresAt": "10-21-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Power Platform Developers",
      "engagement": "Ikea",
      "modified": "2025-07-17 15:55",
      "subBU": "ERP",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "Resourcing",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Mike Lu",
      "initiatedOn": "2024-06-09 18:00",
      "category": "[\"AI, Automation, Integration\"]",
      "primaryTechStack": [
        "Power Platform"
      ],
      "technology": [
        "Power Platform Suite"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "88",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "4-15-2025",
          "expiresAt": "12-24-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "2-17-2025",
          "expiresAt": "10-27-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "9-13-2025",
          "expiresAt": "11-24-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Power Platform and AI",
      "engagement": "MEKO",
      "modified": "2025-07-17 15:55",
      "subBU": "ERP",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "Bids",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Jong",
      "initiatedOn": "2024-06-12 18:00",
      "category": "[\"AI, Automation, Integration\"]",
      "primaryTechStack": [
        "Power Platform"
      ],
      "technology": [
        "AI Modeling"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "92",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "6-5-2025",
          "expiresAt": "11-15-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "12-25-2025",
          "expiresAt": "12-28-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "8-6-2025",
          "expiresAt": "9-28-2027"
        },
        {
          "name": "Access 4",
          "grantedOn": "12-2-2025",
          "expiresAt": "12-22-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Localized Lightweight Large Language Model (LL-LLM)",
      "engagement": "FI BU",
      "modified": "2025-07-17 15:55",
      "subBU": "EUSS",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Pertti",
      "initiatedOn": "2024-07-30 18:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [
        "Python",
        " C++"
      ],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "67",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "8-14-2025",
          "expiresAt": "8-14-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Allow translation for chat and voice(once available)",
      "engagement": "Valmet",
      "modified": "2025-07-17 15:55",
      "subBU": "EUSS",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Manel",
      "initiatedOn": "2024-07-29 18:00",
      "category": "[\"AI, Automation\"]",
      "primaryTechStack": [
        "ServiceNow"
      ],
      "technology": [
        "Exploratory Data Analysis"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "73",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "3-8-2025",
          "expiresAt": "10-20-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "12-11-2025",
          "expiresAt": "12-12-2026"
        },
        {
          "name": "Access 3",
          "grantedOn": "8-4-2025",
          "expiresAt": "10-25-2026"
        },
        {
          "name": "Access 4",
          "grantedOn": "3-6-2025",
          "expiresAt": "10-29-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Summary Generation, Generative API connection",
      "engagement": "Valmet",
      "modified": "2025-07-17 15:55",
      "subBU": "EUSS",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Completed",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Manel",
      "initiatedOn": "2024-07-29 18:00",
      "category": "[\"AI, Automation\"]",
      "primaryTechStack": [
        "ServiceNow"
      ],
      "technology": [
        "Exploratory Data Analysis"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "78",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "1-29-2025",
          "expiresAt": "8-30-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "10-13-2025",
          "expiresAt": "11-13-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "9-21-2025",
          "expiresAt": "10-28-2026"
        },
        {
          "name": "Access 4",
          "grantedOn": "12-25-2025",
          "expiresAt": "12-29-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "AI Internship to Hire: Batch 6 ",
      "engagement": "CAMS",
      "modified": "2025-07-17 15:55",
      "subBU": "BU",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "Resourcing",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Frank",
      "initiatedOn": "2024-01-07 17:00",
      "category": "[\"AI\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "85",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "5-17-2025",
          "expiresAt": "8-29-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "11-4-2025",
          "expiresAt": "12-5-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "8-1-2025",
          "expiresAt": "11-30-2027"
        },
        {
          "name": "Access 4",
          "grantedOn": "9-15-2025",
          "expiresAt": "9-23-2026"
        },
        {
          "name": "Access 5",
          "grantedOn": "4-11-2025",
          "expiresAt": "8-20-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Authentication",
      "engagement": "Foresters",
      "modified": "2025-07-17 15:52",
      "subBU": "GTO Canada",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "Advisor",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "AM Team, Aierien",
      "initiatedOn": "2024-09-09 18:00",
      "category": "[\"Security\"]",
      "primaryTechStack": [
        "Python+ React"
      ],
      "technology": [
        "Chainlit",
        " KnowIT IP"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "60",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "10-8-2025",
          "expiresAt": "12-24-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "1-29-2025",
          "expiresAt": "6-30-2026"
        },
        {
          "name": "Access 3",
          "grantedOn": "3-15-2025",
          "expiresAt": "5-19-2027"
        },
        {
          "name": "Access 4",
          "grantedOn": "9-28-2025",
          "expiresAt": "12-28-2025"
        },
        {
          "name": "Access 5",
          "grantedOn": "10-23-2025",
          "expiresAt": "12-27-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "VoIP - ServiceNow and Genysis",
      "engagement": "CAMS",
      "modified": "2025-07-17 15:50",
      "subBU": "CBPS",
      "priority": "Low",
      "assignee": [
        "Batula, John Michael M"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Boss Ron",
      "initiatedOn": "2024-06-26 18:00",
      "category": "[\"AI, Automation\"]",
      "primaryTechStack": [],
      "technology": [
        "ServiceNow and Genysis"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "84",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "10-4-2025",
          "expiresAt": "10-27-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "2-28-2025",
          "expiresAt": "2-28-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Think.AI - ASR Real-time VA",
      "engagement": "R&D",
      "modified": "2025-07-17 15:49",
      "subBU": "BU",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "Admin",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "AI COP",
      "initiatedOn": "2024-06-30 18:00",
      "category": "[\"AI\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "80",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "10-27-2025",
          "expiresAt": "12-28-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "12-9-2025",
          "expiresAt": "12-29-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "6-27-2025",
          "expiresAt": "12-27-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Multi-Connectivity Channel Native Translation Model ",
      "engagement": "CAMS",
      "modified": "2025-07-17 15:49",
      "subBU": "BU",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Boss Ron",
      "initiatedOn": "2024-07-24 18:00",
      "category": "[\"AI, Automation\"]",
      "primaryTechStack": [
        "ServiceNow"
      ],
      "technology": [
        "Exploratory Data Analysis"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "83",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "2-6-2025",
          "expiresAt": "7-28-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Fusion, Opportunity Exploration",
      "engagement": "AT&T",
      "modified": "2025-07-17 15:48",
      "subBU": "CBPS",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "CBPS",
      "initiatedOn": "2024-01-24 17:00",
      "category": "[\"AI\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [
        "Exploratory Data Analysis",
        " Jupyter"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "106",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "6-15-2025",
          "expiresAt": "11-28-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "9-4-2025",
          "expiresAt": "12-27-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Rituals Usecase Discovery For Bid",
      "engagement": "Rituals",
      "modified": "2025-07-17 15:47",
      "subBU": "EUSS",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P",
        "Panela, Jewel Anne B"
      ],
      "workType": "Bids",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Ron",
      "initiatedOn": "2025-04-25 00:00",
      "category": "[\"AI\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "127",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "1-2-2025",
          "expiresAt": "4-11-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "11-6-2025",
          "expiresAt": "12-29-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "11-10-2025",
          "expiresAt": "11-16-2026"
        },
        {
          "name": "Access 4",
          "grantedOn": "7-24-2025",
          "expiresAt": "8-26-2025"
        },
        {
          "name": "Access 5",
          "grantedOn": "5-2-2025",
          "expiresAt": "10-22-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "SD Trainers",
      "engagement": "R&D",
      "modified": "2025-07-17 15:46",
      "subBU": "BU",
      "priority": "High",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "NEW",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Ron",
      "initiatedOn": "2025-06-29 09:52",
      "category": "",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "2025-06-28",
      "id": "136",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "7-26-2025",
          "expiresAt": "11-29-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "8-12-2025",
          "expiresAt": "11-30-2026"
        },
        {
          "name": "Access 3",
          "grantedOn": "7-20-2025",
          "expiresAt": "7-22-2025"
        },
        {
          "name": "Access 4",
          "grantedOn": "6-10-2025",
          "expiresAt": "8-12-2027"
        },
        {
          "name": "Access 5",
          "grantedOn": "1-28-2025",
          "expiresAt": "12-30-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Normet AMS",
      "engagement": "Normet",
      "modified": "2025-07-17 15:45",
      "subBU": "ERP",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "Bids",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Stephen",
      "initiatedOn": "2024-05-17 09:56",
      "category": "[\"AI, Automation, Integration\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "90",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "11-1-2025",
          "expiresAt": "11-25-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "5-29-2025",
          "expiresAt": "7-30-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "2-6-2025",
          "expiresAt": "2-22-2025"
        },
        {
          "name": "Access 4",
          "grantedOn": "12-28-2025",
          "expiresAt": "12-28-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Power Platform - Power Pages",
      "engagement": "Kekkilä ",
      "modified": "2025-07-17 15:42",
      "subBU": "ERP",
      "priority": "Low",
      "assignee": [
        "Gelacio, Samuel Allen L",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Stephen",
      "initiatedOn": "2024-03-03 17:00",
      "category": "[\"Automation, Fullstack, Integration\"]",
      "primaryTechStack": [
        "Power Plaform"
      ],
      "technology": [
        "Power Pages",
        " Dataverse",
        " HTML",
        " CSS",
        " JS"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "32",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "11-14-2025",
          "expiresAt": "12-30-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "1-9-2025",
          "expiresAt": "5-22-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Help Desk - Potential Usecases",
      "engagement": "BMo",
      "modified": "2025-07-17 15:41",
      "subBU": "EUSS",
      "priority": "Low",
      "assignee": [
        "Fajardo, Edmichael Joil D"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Completed",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Miss Pauline",
      "initiatedOn": "2024-07-30 18:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "43",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "2-8-2025",
          "expiresAt": "11-23-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "5-15-2025",
          "expiresAt": "12-16-2026"
        },
        {
          "name": "Access 3",
          "grantedOn": "4-21-2025",
          "expiresAt": "10-23-2025"
        },
        {
          "name": "Access 4",
          "grantedOn": "5-7-2025",
          "expiresAt": "12-29-2026"
        },
        {
          "name": "Access 5",
          "grantedOn": "5-23-2025",
          "expiresAt": "8-23-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Browser Extension Automation",
      "engagement": "Internal",
      "modified": "2025-07-17 15:40",
      "subBU": "Internal",
      "priority": "Low",
      "assignee": [
        "Rodriguez, Alec Justin",
        "Legaspi, Rosuello Vincent A"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Frank",
      "initiatedOn": "2024-09-05 18:00",
      "category": "[\"Automation\",\"Component Framework\"]",
      "primaryTechStack": [
        "Javascript"
      ],
      "technology": [
        "Browser Extensions"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "64",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "4-10-2025",
          "expiresAt": "10-18-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "10-11-2025",
          "expiresAt": "10-15-2026"
        },
        {
          "name": "Access 3",
          "grantedOn": "11-1-2025",
          "expiresAt": "11-24-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Process - Task Mining",
      "engagement": "R&D",
      "modified": "2025-07-17 15:40",
      "subBU": "Internal",
      "priority": "Low",
      "assignee": [
        "Legaspi, Rosuello Vincent A",
        "Naidas, John Marie L"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Frank",
      "initiatedOn": "2024-09-05 18:00",
      "category": "[\"Automation\"]",
      "primaryTechStack": [
        "Windows 32 API"
      ],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "62",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "12-26-2025",
          "expiresAt": "12-29-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "KnowIT KB Bot Crawler",
      "engagement": "Foresters",
      "modified": "2025-07-17 15:39",
      "subBU": "GTO Canada",
      "priority": "Medium",
      "assignee": [
        "Batas, Jennie Lyn C",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "AM Team, Aierien",
      "initiatedOn": "2024-09-09 18:00",
      "category": "[\"Automation\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [
        "KnowIT IP",
        " Data Mining"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "21",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "2-17-2025",
          "expiresAt": "12-20-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "2-22-2025",
          "expiresAt": "11-30-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "12-13-2025",
          "expiresAt": "12-20-2027"
        },
        {
          "name": "Access 4",
          "grantedOn": "7-8-2025",
          "expiresAt": "7-25-2027"
        },
        {
          "name": "Access 5",
          "grantedOn": "7-28-2025",
          "expiresAt": "10-30-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Problem candidate identification",
      "engagement": "Valmet",
      "modified": "2025-07-17 15:38",
      "subBU": "EUSS",
      "priority": "Low",
      "assignee": [
        "Hizon, Genrev Kiel A",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Manel",
      "initiatedOn": "2024-07-29 18:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [
        "ServiceNow",
        " Classification. Clustering"
      ],
      "technology": [
        "Python"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "42",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "7-29-2025",
          "expiresAt": "9-29-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Predicting incident ticket that are possible major incident candidates",
      "engagement": "Valmet",
      "modified": "2025-07-17 15:38",
      "subBU": "EUSS",
      "priority": "Low",
      "assignee": [
        "Aguas, Nathanael Jhonn R",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Manel",
      "initiatedOn": "2024-07-29 18:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [
        "ServiceNow",
        " Classification",
        " Clustering"
      ],
      "technology": [
        "Python"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "41",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "5-11-2025",
          "expiresAt": "10-22-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "6-25-2025",
          "expiresAt": "9-26-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "KnowIT: Agent Assist Extension",
      "engagement": "R&D",
      "modified": "2025-07-17 15:35",
      "subBU": "CAMS",
      "priority": "Medium",
      "assignee": [
        "Batas, Jennie Lyn C",
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Ron",
      "initiatedOn": "2025-01-09 17:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [
        "Python",
        " JavaScript",
        " W3C"
      ],
      "technology": [
        "Browser Extension"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "11",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "10-22-2025",
          "expiresAt": "12-26-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "PCF - Embedded Analytics",
      "engagement": "Saga Furs",
      "modified": "2025-07-17 15:35",
      "subBU": "ERP",
      "priority": "Low",
      "assignee": [
        "Katada Jr., Frank P",
        "Gelacio, Samuel Allen L"
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Stephen",
      "initiatedOn": "2024-01-10 17:00",
      "category": "[\"AI, Automation, Integration\",\"Component Framework\"]",
      "primaryTechStack": [
        "Power Platform",
        " ReactTS"
      ],
      "technology": [
        "Power BI",
        " Power Apps",
        " Power Automate Cloud",
        " Dataverse"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "98",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "3-6-2025",
          "expiresAt": "4-28-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "12-3-2025",
          "expiresAt": "12-15-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Valmet PI for Spotlight IT team - Quality Incidents, Safety Incidents ",
      "engagement": "Valmet",
      "modified": "2025-07-17 15:34",
      "subBU": "EUSS",
      "priority": "High",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "savin.panikar@valmet.com",
      "initiatedOn": "2025-03-20 17:00",
      "category": "[\"AI, Automation, Fullstack\"]",
      "primaryTechStack": [
        "Azure",
        " Python"
      ],
      "technology": [
        "Sphera"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "2025-05-07",
      "id": "8",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "3-5-2025",
          "expiresAt": "9-9-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "9-15-2025",
          "expiresAt": "9-24-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "EPOS for Finland",
      "engagement": "EPOS",
      "modified": "2025-07-17 15:34",
      "subBU": "EUSS",
      "priority": "High",
      "assignee": [
        "Katada Jr., Frank P"
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Naomi",
      "initiatedOn": "2025-02-13 17:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "14",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "11-14-2025",
          "expiresAt": "12-26-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "4-6-2025",
          "expiresAt": "10-11-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Envision Hackathon Entry",
      "engagement": "R&D",
      "modified": "2025-07-17 15:34",
      "subBU": "CAMS",
      "priority": "Medium",
      "assignee": [
        "Katada Jr., Frank P",
        "Pangindian, Ramher N",
        "Zulueta, Marianne Nicole L"
      ],
      "workType": "Admin",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Ron",
      "initiatedOn": "2025-06-17 00:00",
      "category": "[\"AI\",\"Integration\",\"Automation\"]",
      "primaryTechStack": [
        "Azure"
      ],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "2025-06-23",
      "id": "135",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "10-10-2025",
          "expiresAt": "11-11-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "1-7-2025",
          "expiresAt": "11-21-2026"
        },
        {
          "name": "Access 3",
          "grantedOn": "11-25-2025",
          "expiresAt": "11-30-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Predictive Intelligence API: CSI (Incidents)",
      "engagement": "Valmet",
      "modified": "2025-07-17 15:33",
      "subBU": "EUSS",
      "priority": "Medium",
      "assignee": [
        "Hizon, Genrev Kiel A",
        "Giba, Mark Gerald P"
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Manel",
      "initiatedOn": "2025-02-02 17:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [
        "ServiceNow",
        " Python"
      ],
      "technology": [
        " Classification",
        " Clustering"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "27",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "11-24-2025",
          "expiresAt": "11-30-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "5-3-2025",
          "expiresAt": "11-7-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "6-17-2025",
          "expiresAt": "10-28-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Financial Audit Form",
      "engagement": "CI Fin",
      "modified": "2025-07-17 15:10",
      "subBU": "CBPS",
      "priority": "High",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "DUPLICATE",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Completed",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Miss Divine",
      "initiatedOn": "2025-05-15 00:00",
      "category": "[\"AI\",\"Fullstack\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "2025-06-05",
      "id": "131",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "12-10-2025",
          "expiresAt": "12-14-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "6-9-2025",
          "expiresAt": "12-26-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "7-14-2025",
          "expiresAt": "10-20-2025"
        },
        {
          "name": "Access 4",
          "grantedOn": "11-25-2025",
          "expiresAt": "12-30-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Opportunity Exploration",
      "engagement": "FLR",
      "modified": "2025-07-17 14:59",
      "subBU": "CBPS",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Boss Ron",
      "initiatedOn": "2023-05-15 09:54",
      "category": "[\"AI\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [
        "Exploratory Data Analysis",
        " Jupyter"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "121",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "5-18-2025",
          "expiresAt": "11-23-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "4-14-2025",
          "expiresAt": "12-16-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "1-12-2025",
          "expiresAt": "8-27-2027"
        },
        {
          "name": "Access 4",
          "grantedOn": "5-12-2025",
          "expiresAt": "6-22-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "PCF - Embedded Analytics ",
      "engagement": "Swecon",
      "modified": "2025-07-17 09:56",
      "subBU": "ERP",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Stephen",
      "initiatedOn": "2023-02-21 00:00",
      "category": "[\"AI, Automation, Integration\"]",
      "primaryTechStack": [
        "Power Platform",
        " ReactTS"
      ],
      "technology": [
        "Power BI",
        " Power Apps",
        " Power Automate Cloud",
        " Dataverse"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "112",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "2-6-2025",
          "expiresAt": "2-22-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "5-18-2025",
          "expiresAt": "7-27-2026"
        },
        {
          "name": "Access 3",
          "grantedOn": "2-12-2025",
          "expiresAt": "8-27-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Smart Ticketing",
      "engagement": "Valmet",
      "modified": "2025-07-17 09:55",
      "subBU": "EUSS",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "EUSS",
      "initiatedOn": "2022-07-13 09:54",
      "category": "[\"AI, Automation, Fullstack, Integration\"]",
      "primaryTechStack": [
        "Python",
        " Power Platform",
        " Microsoft 365",
        " Azure",
        " Python",
        " NodeTS",
        " Service Now"
      ],
      "technology": [
        "Text Classification Model ",
        "Virtual Agent",
        "  Teams",
        " Flask"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "124",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "10-8-2025",
          "expiresAt": "10-30-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "EPOS E2E Intelligent Automation",
      "engagement": "EPOS",
      "modified": "2025-07-17 09:54",
      "subBU": "EUSS",
      "priority": "High",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "",
      "initiatedOn": "2023-04-05 09:53",
      "category": "[\"AI\",\"Automation\",\"Integration\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [
        "OCR"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "2025-05-24",
      "id": "130",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "1-10-2025",
          "expiresAt": "4-12-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Alexa Voice Controlled PowerBI Dashboard",
      "engagement": "R&D",
      "modified": "2025-05-19 12:44",
      "subBU": "CAMS",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Boss Ron",
      "initiatedOn": "2022-06-30 18:00",
      "category": "[\"AI, Automation, Fullstack, Integration, IoT\"]",
      "primaryTechStack": [
        "Power Platform",
        " AWS",
        " Azure",
        " Python"
      ],
      "technology": [
        "Flask",
        " Power BI Embedded",
        " AWS Alexa Skill Development",
        " AWS Lambda"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "126",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "5-21-2025",
          "expiresAt": "8-27-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Normet Packing Structure",
      "engagement": "Normet",
      "modified": "2025-05-19 12:44",
      "subBU": "",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Marcus",
      "initiatedOn": "2022-08-31 18:00",
      "category": "[\"Automation, Integration\"]",
      "primaryTechStack": [
        "Power Platform",
        " D365 F&O"
      ],
      "technology": [
        "Power Apps",
        " Dataverse"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "122",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "12-21-2025",
          "expiresAt": "12-26-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "1-3-2025",
          "expiresAt": "12-20-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "CX ITSM Virtual Agent",
      "engagement": "Internal",
      "modified": "2025-05-19 12:44",
      "subBU": "BU",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "Admin",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "CS Talks",
      "initiatedOn": "2023-09-04 18:00",
      "category": "[\"AI, Automation, Fullstack, Integration\"]",
      "primaryTechStack": [
        "Power Platform",
        " Microsoft 365",
        " Azure",
        " Python",
        " ReactTS",
        " NodeTS"
      ],
      "technology": [
        "Text Classification Model",
        " Virtual Agent",
        " Teams",
        " Flask",
        " Power Apps Model Driven",
        " Dataverse"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "120",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "3-18-2025",
          "expiresAt": "6-22-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "12-8-2025",
          "expiresAt": "12-12-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Normet Warehouse",
      "engagement": "Normet",
      "modified": "2025-05-19 12:44",
      "subBU": "",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Marcus",
      "initiatedOn": "2022-08-31 18:00",
      "category": "[\"Automation, Integration\"]",
      "primaryTechStack": [
        "Power Platform",
        " D365 F&O"
      ],
      "technology": [
        "Power Apps",
        " Dataverse"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "123",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "8-20-2025",
          "expiresAt": "10-22-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "8-7-2025",
          "expiresAt": "12-16-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "1-29-2025",
          "expiresAt": "4-30-2026"
        },
        {
          "name": "Access 4",
          "grantedOn": "9-7-2025",
          "expiresAt": "9-23-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Opportunity Exploration",
      "engagement": "Alfa laval",
      "modified": "2025-05-19 12:44",
      "subBU": "CBPS",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "WAITING FOR FEEDBACK",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Ron & Cuerdo, Charisse",
      "initiatedOn": "2023-08-14 18:00",
      "category": "[\"AI\",\"Automation\"]",
      "primaryTechStack": [],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "45",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "1-28-2025",
          "expiresAt": "10-30-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "8-8-2025",
          "expiresAt": "10-26-2026"
        },
        {
          "name": "Access 3",
          "grantedOn": "9-17-2025",
          "expiresAt": "10-30-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "GHRMS Ticket Classification",
      "engagement": "GHRMS",
      "modified": "2025-05-19 12:44",
      "subBU": "",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Boss Ron",
      "initiatedOn": "2023-07-14 18:00",
      "category": "[\"AI, Fullstack\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [
        "Flask",
        " Text Classifcation Model"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "119",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "6-16-2025",
          "expiresAt": "10-29-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Voice of Members",
      "engagement": "Internal",
      "modified": "2025-05-19 12:44",
      "subBU": "CAMS",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Boss Ron",
      "initiatedOn": "2023-09-06 18:00",
      "category": "[\"AI, Fullstack\"]",
      "primaryTechStack": [
        "Python",
        " ReactTS"
      ],
      "technology": [
        "Exploratory Data Analysis",
        " Large Language Model",
        " Virtual Agent",
        " Jupyter"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "118",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "9-1-2025",
          "expiresAt": "12-23-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "6-12-2025",
          "expiresAt": "11-16-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "8-14-2025",
          "expiresAt": "8-30-2027"
        },
        {
          "name": "Access 4",
          "grantedOn": "11-9-2025",
          "expiresAt": "11-23-2027"
        },
        {
          "name": "Access 5",
          "grantedOn": "4-11-2025",
          "expiresAt": "4-13-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "ITSM - Teams Virtual Agent",
      "engagement": "ISIT",
      "modified": "2025-05-19 12:44",
      "subBU": "BU",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Boss Ron",
      "initiatedOn": "2023-09-20 18:00",
      "category": "[\"AI, Automation, Fullstack, Integration\"]",
      "primaryTechStack": [
        "Power Platform",
        " Microsoft 365",
        " Azure",
        " Python",
        " ReactTS",
        " NodeTS"
      ],
      "technology": [
        "Text Classification Model ",
        " Virtual Agent",
        " Teams",
        " Flask"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "116",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "6-15-2025",
          "expiresAt": "6-25-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "6-14-2025",
          "expiresAt": "12-20-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Billion Vector Based Information Retrieval",
      "engagement": "Internal",
      "modified": "2025-05-19 12:44",
      "subBU": "BU",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "In Progress",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Frank",
      "initiatedOn": "2023-09-14 18:00",
      "category": "[\"AI\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "117",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "2-17-2025",
          "expiresAt": "10-22-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Jina Embeddings",
      "engagement": "Internal",
      "modified": "2025-05-19 12:44",
      "subBU": "BU",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Frank",
      "initiatedOn": "2023-10-02 18:00",
      "category": "[\"AI\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "114",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "6-28-2025",
          "expiresAt": "9-30-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "7-18-2025",
          "expiresAt": "11-28-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Neural Machine Translation\t",
      "engagement": "Internal",
      "modified": "2025-05-19 12:44",
      "subBU": "BU",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "clientSubmission": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Frank",
      "initiatedOn": "2023-11-24 17:00",
      "category": "[\"AI\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "113",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "5-17-2025",
          "expiresAt": "11-17-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "11-9-2025",
          "expiresAt": "12-15-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "8-7-2025",
          "expiresAt": "11-22-2025"
        },
        {
          "name": "Access 4",
          "grantedOn": "2-23-2025",
          "expiresAt": "3-29-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "ProperPay Phase 1",
      "engagement": "ProperPay",
      "modified": "2025-05-19 12:44",
      "subBU": "CAMS",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Miss Lolit",
      "initiatedOn": "2023-11-12 17:00",
      "category": "[\"AI, Fullstack\"]",
      "primaryTechStack": [
        "ReactTS"
      ],
      "technology": [
        "Rule-based expert system"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "103",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "12-23-2025",
          "expiresAt": "12-30-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "8-26-2025",
          "expiresAt": "11-26-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "9-6-2025",
          "expiresAt": "9-15-2026"
        },
        {
          "name": "Access 4",
          "grantedOn": "8-26-2025",
          "expiresAt": "8-26-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Farmer",
      "engagement": "R&D",
      "modified": "2025-05-19 12:44",
      "subBU": "CAMS",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "ON HOLD",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Frank, CAMS BDForum",
      "initiatedOn": "2023-03-02 17:00",
      "category": "[\"AI, Automation, Fullstack, Integration\"]",
      "primaryTechStack": [
        "Power Platform",
        " Azure",
        " Python",
        " ReactTS",
        " NodeTS"
      ],
      "technology": [
        "Embedding Semantic Model",
        " Power BI",
        " Scrapy Spiders",
        " MySQL",
        " AZ translate",
        " AZ language",
        " AZ extract"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "102",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "12-12-2025",
          "expiresAt": "12-21-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "1-15-2025",
          "expiresAt": "7-24-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "EWI Classifier and Attrition Predictors",
      "engagement": "Internal",
      "modified": "2025-05-19 12:44",
      "subBU": "CAMS",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Rejected",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Frank",
      "initiatedOn": "2023-04-14 18:00",
      "category": "[\"AI\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "101",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "9-5-2025",
          "expiresAt": "9-18-2025"
        },
        {
          "name": "Access 2",
          "grantedOn": "4-23-2025",
          "expiresAt": "7-26-2026"
        },
        {
          "name": "Access 3",
          "grantedOn": "11-13-2025",
          "expiresAt": "12-13-2025"
        },
        {
          "name": "Access 4",
          "grantedOn": "12-5-2025",
          "expiresAt": "12-17-2026"
        },
        {
          "name": "Access 5",
          "grantedOn": "5-4-2025",
          "expiresAt": "9-11-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Localized Large Language Model\t",
      "engagement": "R&D",
      "modified": "2025-05-19 12:43",
      "subBU": "CAMS",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "COMPLETED",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        },
        "review": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Frank",
      "initiatedOn": "2023-06-02 18:00",
      "category": "[\"AI\"]",
      "primaryTechStack": [
        "Python"
      ],
      "technology": [],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "79",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "6-23-2025",
          "expiresAt": "10-23-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "12-6-2025",
          "expiresAt": "12-6-2027"
        },
        {
          "name": "Access 3",
          "grantedOn": "10-2-2025",
          "expiresAt": "11-30-2025"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Foresight Virtual Agent - V2",
      "engagement": "HR",
      "modified": "2025-05-19 12:43",
      "subBU": "CAMS",
      "priority": "Low",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Approved",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "Boss Ron",
      "initiatedOn": "2022-08-31 18:00",
      "category": "[\"AI, Automation, Fullstack, Integration\"]",
      "primaryTechStack": [
        "Azure",
        " Microsoft 365",
        " Python",
        " NodeTS"
      ],
      "technology": [
        "Sentiment Analysis Model",
        "Virtual Agent",
        " Teams",
        " Flask"
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "33",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "8-19-2025",
          "expiresAt": "8-20-2027"
        },
        {
          "name": "Access 2",
          "grantedOn": "7-19-2025",
          "expiresAt": "10-21-2025"
        },
        {
          "name": "Access 3",
          "grantedOn": "1-21-2025",
          "expiresAt": "4-24-2027"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    },
    {
      "title": "Reco Billing",
      "engagement": "AT&T",
      "modified": "2025-05-19 12:43",
      "subBU": "CBPS",
      "priority": "Medium",
      "assignee": [
        ""
      ],
      "workType": "R&D",
      "status": "IN PROGRESS",
      "stage": {
        "draft": {
          "initiatedOn": "undefined",
          "updatedOn": "undefined",
          "status": "Waiting For Approval",
          "reviewedBy": "Frank",
          "comment": ""
        }
      },
      "from": "CBPS",
      "initiatedOn": "2023-02-12 17:00",
      "category": "[\"Automation, Integration\"]",
      "primaryTechStack": [
        "Power Platform"
      ],
      "technology": [
        "Power Apps Model Driven",
        " Dataverse",
        " Power Automate Cloud",
        " Power BI "
      ],
      "highLevelDesign": "",
      "wireframes": "",
      "attachments": "0",
      "estimates": "",
      "dueOn": "",
      "id": "10",
      "completedOn": "",
      "accesses": [
        {
          "name": "Access 1",
          "grantedOn": "10-22-2025",
          "expiresAt": "10-24-2026"
        },
        {
          "name": "Access 2",
          "grantedOn": "6-3-2025",
          "expiresAt": "8-22-2026"
        }
      ],
      "description": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.",
      "isVisible": true
    }
  ],
  "reusables": [
    {
      "title": "Authentication Login Form",
      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
      "componentType": "Authentication",
      "implementations": [
        "Project 1",
        "Project 2",
        "Project 3"
      ],
      "href": "reusables/authentication_login_form",
      "isVisible": true
    },
    {
      "title": "Authentication Using LDAP",
      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
      "componentType": "Authentication",
      "implementations": [
        "Project 1",
        "Project 2"
      ],
      "href": "reusables/authentication_using_ldap",
      "isVisible": true
    },
    {
      "title": "Authentication Using MSAL",
      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
      "componentType": "Authentication",
      "implementations": [
        "Project 1",
        "Project 2",
        "Project 3"
      ],
      "href": "reusables/authentication_using_msal",
      "isVisible": true
    },
    {
      "title": "Grafana",
      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
      "componentType": "Integration",
      "implementations": [
        "Project 1",
        "Project 2",
        "Project 3",
        "Project 4"
      ],
      "href": "reusables/grafana",
      "isVisible": true
    }
  ]
}